import React from 'react';

// YMAPS
import Map from '../../../../common/components/map/map';

import { Drawer } from 'antd';

const DrawerMap = props => {
  const { title, visible, handleClose, type, markers } = props;

  return (
    <Drawer
      title={title}
      placement="left"
      width={896}
      visible={visible}
      destroyOnClose={true}
      onClose={handleClose}
    >
      <Map
        data={{
          type,
          markers,
        }}
      />
    </Drawer>
  );
};

export default DrawerMap;
